// extracted by mini-css-extract-plugin
export default {"header":"rRquZLp0F2IPdec2YsgC","staticPageHeader":"UdsEzvcRMGHW1fas_TMX","noBorder":"Hbys01zdsNj4bGBfJZKg","subtitle":"YgmnIQRB1caubQEXWZSk"};